import React, { useEffect, useState, useRef } from "react";
import {
    Box,
    Typography,
    Button,
    IconButton,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Dialog,
    DialogTitle,
    DialogContent,
    Chip,
    Stack,
    useTheme,
    useMediaQuery,
    DialogActions,
} from "@mui/material";
import { Add, Edit, Delete, Star, StarBorder, Close, Sms } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { waGetMenus, waDeleteMenu, waActivateMenu } from "../wa/api/wa_menu_Api";
import { Settings } from "@mui/icons-material";
import { TextField } from "@mui/material";
import axios from "axios";
import WaMenuEditor from "./WaMenuEditor";
import WaOpcionEditor from "./WaOpcionEditor";
import SmsResponsablesManager from "./SmsResponsablesManager";
import Navbar from "../Navbar";
import { titulonavbar } from "../../services/apirest";

export default function WaMenuList() {
    const { enqueueSnackbar } = useSnackbar();
    const [menus, setMenus] = useState([]);
    const [openMenuDialog, setOpenMenuDialog] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState(null);
    const [smsManagerOpen, setSmsManagerOpen] = useState(false); //responsables SMS
    // único modal para opciones
    const [openOpciones, setOpenOpciones] = useState(false);
    const opcionEditorRef = useRef(null);

    const [openPrefijo, setOpenPrefijo] = useState(false);
    const [prefijo, setPrefijo] = useState("");
    const [loadingPrefijo, setLoadingPrefijo] = useState(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const loadMenus = async () => {
        const data = await waGetMenus();
        setMenus(data || []);
    };

    useEffect(() => {
        loadMenus();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("¿Eliminar este menú?")) return;
        await waDeleteMenu(id);
        enqueueSnackbar("🗑️ Menú eliminado correctamente", { variant: "info" });
        await loadMenus();
    };

    const handleActivate = async (id) => {
        await waActivateMenu(id);
        enqueueSnackbar("⭐ Menú principal actualizado", { variant: "success" });
        await loadMenus();
    };

    const API = (localStorage.getItem("API") || "https://wabot.netizar.com").replace(/\/+$/, "");
    const token = localStorage.getItem("token") || "";
    const api = axios.create({
        baseURL: API,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    const loadPrefijo = async () => {
        try {
            setLoadingPrefijo(true);
            const { data } = await api.get("/api/config/prefijo");
            setPrefijo(data.prefijo || "");
        } catch (err) {
            enqueueSnackbar("⚠️ Error al cargar prefijo", { variant: "error" });
        } finally {
            setLoadingPrefijo(false);
        }
    };

    const savePrefijo = async () => {
        try {
            await api.post("/api/config/prefijo", { prefijo });
            enqueueSnackbar("✅ Prefijo guardado correctamente", { variant: "success" });
            setOpenPrefijo(false);
        } catch (err) {
            enqueueSnackbar("❌ Error al guardar prefijo", { variant: "error" });
        }
    };

    if (titulonavbar === 'DevExt') {
        return (
            <>
                <Navbar />
                <Box sx={{ p: 4, textAlign: "center" }}>
                    <Typography variant="h5" color="error" sx={{ mt: 4 }}>
                        ⚠️ Panel no disponible en desarrollo
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        Este panel solo funciona en el entorno de producción.
                    </Typography>
                </Box>
            </>
        );
    }
    return (
        <>
            <Navbar />
            <Box sx={{ p: 3 }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 2,
                    }}
                >
                    <Typography variant="h5">🧭 Gestión de Menús del Bot</Typography>

                    <Stack direction="row" spacing={1} alignItems="center">
                        <IconButton
                            color="primary"
                            title="Configurar prefijo de respuesta"
                            onClick={() => {
                                setOpenPrefijo(true);
                                loadPrefijo();
                            }}
                        >
                            <Settings />
                        </IconButton>
                        <IconButton
                            color="secondary"
                            title="Gestionar responsables SMS"
                            onClick={() => setSmsManagerOpen(true)}
                        >
                            <Sms />
                        </IconButton>
                        <Button
                            variant="contained"
                            size="small"
                            startIcon={<Add fontSize="small" />}
                            onClick={() => {
                                setSelectedMenu(null);
                                setOpenMenuDialog(true);
                            }}
                        >
                            Nuevo menú
                        </Button>
                    </Stack>

                </Box>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow
                                sx={{
                                    backgroundColor: "#f5f5f5",
                                    "& th": { py: 0.5, px: 1, fontSize: "0.85rem", verticalAlign: "top" },
                                }}
                            >
                                <TableCell>ID</TableCell>
                                <TableCell>Nombre</TableCell>
                                <TableCell>Título</TableCell>
                                <TableCell>Descripción</TableCell>
                                <TableCell>Disponible</TableCell>
                                <TableCell>Principal</TableCell>
                                <TableCell>Opciones</TableCell>
                                <TableCell align="right">Acciones</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {menus.map((m) => (
                                <TableRow
                                    key={m.id}
                                    hover
                                    sx={{
                                        backgroundColor: m.es_default ? "rgba(255, 235, 59, 0.18)" : "inherit",
                                        "& td": { py: 0.6, px: 1, fontSize: "0.9rem", verticalAlign: "top" },
                                    }}
                                >
                                    <TableCell>{m.id}</TableCell>
                                    <TableCell>{m.nombre}</TableCell>
                                    <TableCell sx={{ whiteSpace: "pre-line" }}>{m.titulo}</TableCell>
                                    <TableCell>
                                        {m.descripcion
                                            ? m.descripcion.length > 110
                                                ? m.descripcion.substring(0, 110) + "…"
                                                : m.descripcion
                                            : "-"}
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={m.disponible ? "Sí" : "No"}
                                            color={m.disponible ? "success" : "default"}
                                            size="small"
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        {m.es_default ? (
                                            <Star color="warning" />
                                        ) : (
                                            <IconButton
                                                size="small"
                                                onClick={() => handleActivate(m.id)}
                                                title="Marcar como principal"
                                            >
                                                <StarBorder />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                    <TableCell>{m.opciones?.length || 0}</TableCell>
                                    <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                                        <IconButton
                                            color="primary"
                                            title="Editar menú"
                                            onClick={() => {
                                                setSelectedMenu(m);
                                                setOpenMenuDialog(true);
                                            }}
                                        >
                                            <Edit />
                                        </IconButton>

                                        <IconButton
                                            color="secondary"
                                            title="Editar opciones"
                                            onClick={() => {
                                                setSelectedMenu(m);
                                                setOpenOpciones(true);
                                            }}
                                        >
                                            <Add />
                                        </IconButton>

                                        <IconButton
                                            color="error"
                                            title="Eliminar menú"
                                            onClick={() => handleDelete(m.id)}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}

                            {menus.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        No hay menús cargados todavía
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Modal Crear/Editar Menú */}
                <Dialog
                    open={openMenuDialog}
                    onClose={() => setOpenMenuDialog(false)}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>{selectedMenu ? "Editar menú" : "Nuevo menú"}</DialogTitle>
                    <DialogContent>
                        <WaMenuEditor
                            menu={selectedMenu}
                            onSave={async () => {
                                await loadMenus();
                                setSelectedMenu(null);
                                setOpenMenuDialog(false);
                            }}
                        />
                    </DialogContent>
                </Dialog>

                {/* Modal Opciones (el ÚNICO dialog para opciones) */}
                <Dialog
                    open={openOpciones}
                    onClose={() => setOpenOpciones(false)}
                    fullWidth
                    maxWidth="lg"
                    fullScreen={fullScreen}
                    PaperProps={{
                        sx: { width: { xs: "95vw", md: "1100px" }, maxHeight: "90vh" },
                    }}
                >
                    <DialogTitle
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            pr: 2,
                            py: 1,
                        }}
                    >
                        <Typography variant="h6">Opciones de: {selectedMenu?.nombre}</Typography>

                        <Stack direction="row" spacing={1} alignItems="center">
                            <Button
                                variant="contained"
                                size="small"
                                startIcon={<Add fontSize="small" />}
                                onClick={() => opcionEditorRef.current?.addNewOption?.()}
                            >
                                Nueva opción
                            </Button>
                            <IconButton onClick={() => setOpenOpciones(false)} aria-label="Cerrar">
                                <Close />
                            </IconButton>
                        </Stack>
                    </DialogTitle>

                    <DialogContent dividers sx={{ p: 0 }}>
                        {selectedMenu && (
                            <WaOpcionEditor
                                ref={opcionEditorRef}
                                menuId={selectedMenu.id}
                                onSaved={() => loadMenus()}
                            />
                        )}
                    </DialogContent>
                </Dialog>
                {/* Prefijo respuestas automatica */}
                <Dialog open={openPrefijo} onClose={() => setOpenPrefijo(false)} fullWidth maxWidth="sm">
                    <DialogTitle>⚙️ Prefijo de respuestas automáticas</DialogTitle>
                    <DialogContent dividers>
                        <Typography variant="body2" gutterBottom>
                            Este texto se antepone a los mensajes enviados al usuario cuando RRHH resuelve una tarea.
                            <br />
                            Podés usar variables:
                        </Typography>
                        <ul style={{ marginTop: 0, marginBottom: 10, paddingLeft: 20, fontSize: "0.9rem" }}>
                            <li><b>{'{nombre}'}</b> → nombre del empleado</li>
                            <li><b>{'{fecha}'}</b> → fecha actual</li>
                            <li><b>{'{item}'}</b> → tipo de solicitud o menú</li>
                        </ul>

                        <TextField
                            label="Texto del prefijo"
                            fullWidth
                            multiline
                            minRows={4}
                            value={prefijo}
                            onChange={(e) => setPrefijo(e.target.value)}
                            disabled={loadingPrefijo}
                        />

                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                            Ejemplo: Hola {`{nombre}`}, respondiendo a tu consulta del día {`{fecha}`} sobre {`{item}`}, resolvimos lo siguiente:
                        </Typography>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => setOpenPrefijo(false)}>Cerrar</Button>
                        <Button onClick={savePrefijo} variant="contained" disabled={loadingPrefijo}>
                            Guardar
                        </Button>
                    </DialogActions>
                </Dialog>

                <SmsResponsablesManager
                    open={smsManagerOpen}
                    onClose={() => setSmsManagerOpen(false)}
                />
            </Box>
        </>
    );
}
